import { createI18n } from 'vue-i18n'

export const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem("currentLangId")
    ? {
        "1751CDBCE1E": "de",
        "186559F7DBF": "fr",
        "180BC941F1F": "en",
        "187B79C94AC": "it",
      }[localStorage.getItem("currentLangId") as string] || "de"
    : "de",
  fallbackLocale: "de",
  messages: { de: {}, fr: {}, en: {}, it: {} },
});

/**
 * Reaktives t():
 * Liest die aktuelle Locale-Ref, damit das Template eine Dep hat
 * und bei Locale-Änderung re-rendered.
 */
export const t = (key: string, params?: Record<string, unknown>) => {
  const g: any = i18n.global
  // establish reactive dependency
  if (g.locale && typeof g.locale !== 'string') {
    // legacy:false => Ref
    void g.locale.value
  }
  // (legacy:true hätte string, dann gibt's keine Dep – bei dir nutzen wir legacy:false)
  return g.t(key, params as any)
}

export function setI18nMessages(locale: string, translations: Record<string, string>) {
  i18n.global.mergeLocaleMessage(locale, translations)
}

export default i18n
